<h2 mat-dialog-title>{{ data.title || 'Select Organization' }}</h2>

<mat-dialog-content class="tw-max-h-96 tw-overflow-y-auto">
  <p class="tw-text-sm tw-text-gray-600 dark:tw-text-gray-400 tw-mb-4">
    {{ data.message || 'Select the organization where you want to copy this item' }}
  </p>
  
  <div class="tw-space-y-2">
    <div 
      *ngFor="let org of availableOrgs"
      (click)="onOrgSelect(org.id)"
      class="tw-p-3 tw-rounded-lg tw-border tw-cursor-pointer tw-transition-all"
      [ngClass]="{
        'tw-border-primary_purple-500 tw-bg-primary_purple-50 dark:tw-bg-primary_purple-900/20': selectedOrgId === org.id,
        'tw-border-gray-300 dark:tw-border-gray-700 hover:tw-border-gray-400 dark:hover:tw-border-gray-600': selectedOrgId !== org.id
      }">
      <div class="tw-flex tw-items-center tw-justify-between">
        <div class="tw-flex-1">
          <div class="tw-font-medium tw-text-gray-900 dark:tw-text-gray-100">
            {{ org.name }}
            <span *ngIf="isCurrentOrg(org.id)" class="tw-ml-2 tw-text-xs tw-text-gray-500 dark:tw-text-gray-400">
              (Current)
            </span>
          </div>
          <div *ngIf="org.role" class="tw-text-xs tw-text-gray-600 dark:tw-text-gray-400 tw-mt-1">
            Role: {{ org.role }}
          </div>
        </div>
        <div class="tw-ml-4">
          <mat-icon 
            *ngIf="selectedOrgId === org.id"
            class="tw-text-primary_purple-500">
            check_circle
          </mat-icon>
          <mat-icon 
            *ngIf="selectedOrgId !== org.id"
            class="tw-text-gray-400">
            radio_button_unchecked
          </mat-icon>
        </div>
      </div>
    </div>
  </div>
  
  <div *ngIf="availableOrgs.length === 0" class="tw-text-center tw-py-8 tw-text-gray-500">
    No organizations available
  </div>
  
  <div *ngIf="availableOrgs.length === 1" class="tw-mt-4 tw-p-3 tw-bg-yellow-50 dark:tw-bg-yellow-900/20 tw-rounded-lg tw-border tw-border-yellow-300 dark:tw-border-yellow-700">
    <div class="tw-flex tw-items-start">
      <mat-icon class="tw-text-yellow-600 dark:tw-text-yellow-400 tw-mr-2">info</mat-icon>
      <p class="tw-text-sm tw-text-yellow-800 dark:tw-text-yellow-200">
        You only have access to one organization. The item will be copied within the same organization.
      </p>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="tw-flex tw-justify-end tw-gap-2">
  <button 
    mat-button 
    (click)="onCancel()">
    Cancel
  </button>
  <button 
    mat-flat-button 
    color="primary"
    [disabled]="!selectedOrgId"
    (click)="onConfirm()">
    Copy to Selected Organization
  </button>
</mat-dialog-actions>